<script>

export default {
	methods: {
    mxfSendParent(method, datos){
      window.parent.postMessage({
        func: method,
        message: datos
      }, "*");
    }
  }
}

</script>